import { facebook, instagram, linkedin, twitter } from "../assets";
import PortfolioImg1 from "../assets/PortfolioImg1.png";
import PortfolioImg2 from "../assets/PortfolioImg2.png";
import PortfolioImg3 from "../assets/PortfolioImg3.png";
import PortfolioImg4 from "../assets/PortfolioImg4.png";

export const navLinks = [
  {
    id: "home",
    title: "Home",
  },
  {
    id: "pricing",
    title: "Pricing",
  },
  {
    id: "portfolio",
    title: "Portfolio",
  },
  {
    id: "faq",
    title: "FAQ",
  },
];

export const features = [
  {
    id: "feature-1",
    title: "InstaBoost : Instagram Organic Growth",
    content:
      "The best credit cards offer some tantalizing combinations of promotions and prizes",
  },
  {
    id: "feature-2",
    title: "Creative Catalyst: Content Creation",
    content:
      "We take proactive steps make sure your information and transactions are secure.",
  },
  {
    id: "feature-3",
    title: "Social Fusion: Instagram Organic Growth + Content Creation",
    content:
      "A balance transfer credit card can save you a lot of money in interest charges.",
  },
];

export const feedback = [
  {
    id: 0,
    name: "xdesignstudiox",
    location: "Germany ",
    content: (
      <p>
        I highly recommend Shikhar. Great communication, insights and our
        Instagram page got more engagement and growth. Will continue working
        together in the future. Great job and always delivered on time! Thank
        you very much for all your work for us.
      </p>
    ),
  },
  {
    id: 1,
    name: "mindrealities",
    location: "United States",
    content: (
      <p>
        Very pleasant working with the freelancer to grow my Instagram followers
        organically. For about a month, he grew my follower to practically
        non-existent to close to 300 followers. He is very responsive and
        attentive to my business needs. Will be back for more work. Thanks!
      </p>
    ),
  },
  {
    id: 2,
    name: "cv_swiss",
    location: "Switzerland",
    content: (
      <p>
        Shikhar was very helpful and provided great results. The services
        started fast, delivered on point and as promised ! Thank you Shikhar for
        your excellent work
      </p>
    ),
  },
  {
    id: 3,
    name: "matare2022",
    location: "United States",
    content: (
      <p>
        Second time using him. I will use him and his team again. I have many
        new legitimate followers that are relevant to my brand! Highly recommend
        him for his professionalism.
      </p>
    ),
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "Total clients",
    value: "500+",
  },
  {
    id: "stats-2",
    title: "Fiverr Rating",
    value: "4.9/5",
  },
  {
    id: "stats-3",
    title: "Engagement",
    value: "10M+",
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/bright_ripple_studios/?utm_source=ig_web_button_share_sheet",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/profile.php?id=61581937077041",
  },
  {
    id: "social-media-3",
    icon: twitter,
    link: "https://x.com/BRipple14993",
  },
  {
    id: "social-media-4",
    icon: linkedin,
    link: "https://www.linkedin.com/company/bright-ripple-studios/?viewAsMember=true",
  },
];

export const portfolioImages = [
  {
    type: "image",
    niche: "Artist",
    plan: "30 Days",
    img: PortfolioImg1,
  },
  {
    type: "image",
    niche: "Products",
    plan: "30 Days",
    img: PortfolioImg2,
  },
  {
    type: "image",
    niche: "Personal Brand",
    plan: "30 Days",
    img: PortfolioImg3,
  },
  {
    type: "image",
    niche: "Motivation",
    plan: "30 Days",
    img: PortfolioImg4,
  },
];

export const portfolioVideos = [
  {
    type: "video",
    niche: "AI",
    src: "https://fast.wistia.net/embed/iframe/o5jy98gu49?seo=false&videoFoam=false",
  },
  {
    type: "video",
    niche: "Information",
    src: "https://fast.wistia.net/embed/iframe/k8cglr87et?seo=false&videoFoam=false",
  },
  {
    type: "video",
    niche: "Information",
    src: "https://fast.wistia.net/embed/iframe/4fq34vq13j?seo=false&videoFoam=false",
  },
];

export const pricing = [
  {
    name: "Launchpad",
    price: "$199",
    metaInfo: "A simple start if you’re just testing the waters",
    Detail: [
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "3 AI Twin Videos",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Scriptwriting, Storyboarding & Editing",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Posting on 2 Platforms",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "3 Revisions",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Captions & Hashtags",
      },
       {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Delivery Within 21 Days",
      },
    ],
  },
  {
    name: "Brand Accelerator",
    price: "$555",
    metaInfo: "Built for brands ready to lead, not just start",
    Detail: [
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "8 AI Twin Videos",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Scriptwriting, Storyboarding & Editing",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Posting Upto 4 Platforms",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "16 Revisions",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Captions & Hashtags",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Content Pillar Development",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "60 hrs/m Manual Community Engagement",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Weekly Reporting",
      },
    ],
  },
  {
    name: "Custom Edge",
    price: "Flexible pricing",
  metaInfo: "Custom growth, total control",
    Detail: [
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Choice of video styles (AI Twin, Avatar, Faceless, or Promotional)",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Social media management & optimization (Instagram, YouTube, LinkedIn)",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Branded assets & theme page optimization",
      },
      {
        src: "https://img.icons8.com/color/96/null/checked--v1.png",
        content: "Add-ons: Stories, Carousels, Thumbnails & more",
      },
      
      
    ],
  },
];

export const faqs = [

{
  question: "How do you handle my login details or personal data securely?",
  answer:
    "All client data and login credentials are handled with strict confidentiality and used only for the agreed project.",
},
{
  question: "Do I need to be on camera every time?",
  answer:
    "No. Just one-time raw footage (1–2 minutes), and we’ll create your AI Digital Twin for all future videos.",
},
{
  question: "Will the AI Digital Twin sound natural?",
  answer:
    "Yes — your tone, style, and presence are preserved. We make it look and feel authentically you.",
},
{
  question: "Can you manage my Instagram and LinkedIn too?",
  answer:
    "Absolutely. We can script, edit, and post directly for you, plus optimize captions, hashtags, and engagement.",
},
{
  question: "Do you provide custom requests?",
  answer:
    "Yes — that’s what Custom edge is for. Book a call, and we’ll build a plan around your exact needs.",
},
{
  question: "How many platforms can you manage?",
  answer:
    "We currently upload and manage content on YouTube, Instagram, and LinkedIn.",
},

  {
  question: "Why should you choose us?",
  answer:
    "You'll get 100% MONEY BACK if you're not satisfied with our service. Beyond that, you’re not just hiring one person — you’re getting a dedicated team of experienced digital marketers, AI engineers, video editors, and scriptwriters who work together to deliver high-quality results tailored to your brand.",
},
  {
    question: "What kind of videos can I edit with your service?",
    answer:
      "We can edit a wide variety of short-form videos, including reels, Instagram stories, TikTok videos, YouTube Shorts, and more! Whether it's funny clips, educational content, or product demos, our editor lets you unleash your creativity.",
  },
  {
    question: "What features does your service offer?",
    answer:
      "We provide precise trimming and cutting, seamless transitions, dynamic motion graphics, engaging B-roll integration, high-quality sound design with music and effects, text overlays and branded elements, advanced color grading, and stylish filters.",
  },
{
  question: "Can I still use my account while you provide the service?",
  answer:
    "Yes, absolutely. You can continue using your account as usual — our work will not interrupt your access or regular activity.",
},
];
